// extracted by css-extract-rspack-plugin
export default {"Token":"SingleSelectToken-module__Token__chjF3C8","colorIndicator":"SingleSelectToken-module__colorIndicator__Xi4KECH"};